import { Row } from "antd";

export const CustomRow = ({ children }: { children: React.ReactNode }) => {

  return (
    <Row style={{ width: '200px' }}>
      {children}
    </Row>
  )
}